import { API } from '../components/Initilization';

// Public endpoints
export const getMainCategories = () => {
  return API.get('/api/product/categories/');
};

export const getSubCategories = (mainCategoryId = null) => {
  const url = mainCategoryId 
    ? `/api/product/sub-categories/${mainCategoryId}/` 
    : '/api/product/sub-categories/';
  return API.get(url);
};

export const getColors = () => {
  return API.get('/api/product/colors/');
};

export const getQualities = () => {
  return API.get('/api/product/qualities/');
};

export const getUnorderableProducts = () => {
  return API.get('/api/product/unorderable-products/');
};

export const getPuzzleProducts = () => {
  return API.get('/api/product/puzzle-products/');
};

export const getSizes = (categoryType = null) => {
  const url = categoryType 
    ? `/api/product/sizes/${categoryType}/` 
    : '/api/product/sizes/';
  return API.get(url);
};

export const getProducts = (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.search) params.append('search', filters.search);
  if (filters.main_category && filters.main_category !== 'null') params.append('main_category', filters.main_category);
  if (filters.sub_category && filters.sub_category !== 'null') params.append('sub_category', filters.sub_category);
  if (filters.is_available !== undefined && filters.is_available !== null && filters.is_available !== '') 
    params.append('is_available', filters.is_available);
  if (filters.is_featured !== undefined && filters.is_featured !== null && filters.is_featured !== '') 
    params.append('is_featured', filters.is_featured);
  if (filters.is_new !== undefined && filters.is_new !== null && filters.is_new !== '') 
    params.append('is_new', filters.is_new);
  if (filters.is_best_seller !== undefined && filters.is_best_seller !== null && filters.is_best_seller !== '') 
    params.append('is_best_seller', filters.is_best_seller);
  if (filters.is_orderable !== undefined && filters.is_orderable !== null && filters.is_orderable !== '') 
    params.append('is_orderable', filters.is_orderable);
  if (filters.min_price && filters.min_price !== 'null') params.append('min_price', filters.min_price);
  if (filters.max_price && filters.max_price !== 'null') params.append('max_price', filters.max_price);
  if (filters.ordering) params.append('ordering', filters.ordering);
  if (filters.page) params.append('page', filters.page);
  if (filters.page_size) params.append('page_size', filters.page_size);
  
  const url = `/api/product/products/${params.toString() ? `?${params.toString()}` : ''}`;
  console.log('API Request URL:', url);
  return API.get(url);
};

export const getProductBySlug = (slug) => {
  return API.get(`/api/product/products/${slug}/`);
};

// Admin endpoints (require authentication)
export const adminCreateProduct = (productData) => {
  return API.post('/api/product/admin/product/create/', productData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    NeedsAuthorization: true
  });
};

export const adminUpdateProduct = (productId, productData) => {
  return API.put(`/api/product/admin/product/update/${productId}/`, productData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    NeedsAuthorization: true
  });
};

export const adminDeleteProduct = (productId) => {
  return API.delete(`/api/product/admin/product/delete/${productId}/`, {
    NeedsAuthorization: true
  });
};

// Variant management
export const adminCreateVariant = (variantData) => {
  return API.post('/api/product/admin/variant/', variantData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    NeedsAuthorization: true
  });
};

export const adminUpdateVariant = (variantId, variantData) => {
  return API.put(`/api/product/admin/variant/${variantId}/`, variantData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    NeedsAuthorization: true
  });
};

export const adminDeleteVariant = (variantId) => {
  return API.delete(`/api/product/admin/variant/${variantId}/`, {
    NeedsAuthorization: true
  });
};

// Variant size management
export const adminCreateVariantSize = (sizeData) => {
  return API.post('/api/product/admin/variant-size/', sizeData, {
    NeedsAuthorization: true
  });
};

export const adminUpdateVariantSize = (sizeId, sizeData) => {
  return API.put(`/api/product/admin/variant-size/${sizeId}/`, sizeData, {
    NeedsAuthorization: true
  });
};

export const adminDeleteVariantSize = (sizeId) => {
  return API.delete(`/api/product/admin/variant-size/${sizeId}/`, {
    NeedsAuthorization: true
  });
};

// Image management
export const adminAddProductImage = (imageData) => {
  return API.post('/api/product/admin/image/', imageData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    NeedsAuthorization: true
  });
};

export const adminDeleteProductImage = (imageId) => {
  return API.delete(`/api/product/admin/image/${imageId}/`, {
    NeedsAuthorization: true
  });
};

// Feature management
export const adminCreateFeature = (featureData) => {
  return API.post('/api/product/admin/feature/', featureData, {
    NeedsAuthorization: true
  });
};

export const adminUpdateFeature = (featureId, featureData) => {
  return API.put(`/api/product/admin/feature/${featureId}/`, featureData, {
    NeedsAuthorization: true
  });
};

export const adminDeleteFeature = (featureId) => {
  return API.delete(`/api/product/admin/feature/${featureId}/`, {
    NeedsAuthorization: true
  });
};

// Add to your existing API service file
export const getOrderDetail = (orderId) => {
  return API.get(`/api/order/order-detail/${orderId}`, { NeedsAuthorization: true });
};

export const repurchaseOrder = (orderId) => {
  return API.post(`/api/order/repurchase/${orderId}`, {}, { NeedsAuthorization: true });
};